"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBusinessCategory = exports.BadgeValue = void 0;
exports.getPageContext = getPageContext;
exports.trackEvent = trackEvent;
exports.trackGoogleAnalyticsEvent = trackGoogleAnalyticsEvent;
exports.trackGoogleTagManagerEvent = trackGoogleTagManagerEvent;
exports.trackIdentifyUser = trackIdentifyUser;
exports.trackUserCreated = trackUserCreated;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
var _storage = require("../util/storage");
var _vendorUtils = require("../marketplace/vendorUtils");
var _vendorTaxonomyKeys = require("../marketplace/vendorTaxonomyKeys");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BadgeValue = exports.BadgeValue = /*#__PURE__*/function (BadgeValue) {
  BadgeValue["QUICK_RESPONDER"] = "quick_responder";
  return BadgeValue;
}({});
function getPageContext() {
  var _window;
  return {
    path: window.location.pathname,
    search: window.location.search,
    referrer: ((_window = window) === null || _window === void 0 || (_window = _window.zola) === null || _window === void 0 ? void 0 : _window.referrer) || document.referrer,
    url: window.location.href,
    title: document.title
  };
}

// Incomplete list of event names

/**
 * Guard / gatekeeper to blacklist certain events.
 *
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function canTrack(eventName, payload) {
  if (eventName === 'CTA Viewed') {
    // If we want to allowlist some CTA viewed events, we can do that with the payload
    return false;
  }
  return true;
}
function trackEvent(eventName, payload) {
  var _window2;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var optionsFinal = options || {};
  optionsFinal.page = getPageContext();
  if ((_window2 = window) !== null && _window2 !== void 0 && (_window2 = _window2.analytics) !== null && _window2 !== void 0 && _window2.track && canTrack(eventName, payload)) {
    window.analytics.track(eventName, payload, optionsFinal);
  }
}
function trackIdentifyUser(userId, traits, options) {
  var optionsFinal = options || {};
  optionsFinal.page = getPageContext();
  if (window && window.analytics) {
    window.analytics.identify(userId, traits, optionsFinal);
  }
}
/**
 * Sends an event to GA through Segment.  Does not go ot other Segment destinations.
 * https://segment.com/docs/connections/destinations/catalog/google-analytics/#track
 * @param eventName The Event name will become the action in GA
 * @param payload
 */
function trackGoogleAnalyticsEvent(eventName, payload) {
  var options = {
    integrations: {
      All: false,
      'Google Analytics': true
    }
  };
  trackEvent(eventName, payload, options);
}

/**
 * Fires a GTM event.  Does not go to other Segment destinations.
 * @param eventName
 * @param payload payload data will be pushed to the dataLayer
 */
function trackGoogleTagManagerEvent(eventName, payload) {
  var options = {
    integrations: {
      All: false,
      'Google Tag Manager': true
    }
  };
  trackEvent(eventName, payload, options);
}
function getCampaignContext() {
  var _document;
  if ((_document = document) !== null && _document !== void 0 && _document.cookie) {
    var utm_source = (0, _storage.getCookie)('utm_source') || undefined;
    var utm_campaign = (0, _storage.getCookie)('utm_campaign') || undefined;
    var utm_term = (0, _storage.getCookie)('utm_term') || undefined;
    var utm_content = (0, _storage.getCookie)('utm_content') || undefined;
    var utm_medium = (0, _storage.getCookie)('utm_medium') || undefined;
    var hasUtmCookies = [utm_source, utm_campaign, utm_term, utm_content, utm_medium].reduce(function (acc, cur) {
      return acc || Boolean(cur);
    }, false);
    if (hasUtmCookies) {
      return {
        content: utm_content,
        medium: utm_medium,
        name: utm_campaign,
        source: utm_source,
        term: utm_term
      };
    }
  }
  return undefined;
}
function trackUserCreated(email, pkey) {
  var payload = {
    email: email,
    pkey: pkey
  };
  var campaignContext = getCampaignContext();
  var options = campaignContext ? {
    campaign: campaignContext
  } : undefined;
  trackEvent('User Created', payload, options);
}
var getBusinessCategory = exports.getBusinessCategory = (0, _vendorUtils.getVendorTaxonomySwitchFunc)(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _vendorTaxonomyKeys.VENUES_TAXONOMY_KEY, 'VENUE'), _vendorTaxonomyKeys.BANDS_DJS_TAXONOMY_KEY, 'MUSICIAN_DJ'), _vendorTaxonomyKeys.BAR_SERVICES_TAXONOMY_KEY, 'BAR_SERVICES'), _vendorTaxonomyKeys.CAKES_DESSERTS_TAXONOMY_KEY, 'CAKES_DESSERTS'), _vendorTaxonomyKeys.CATERING_TAXONOMY_KEY, 'CATERER'), _vendorTaxonomyKeys.FLORISTS_TAXONOMY_KEY, 'FLORIST'), _vendorTaxonomyKeys.HAIR_MAKEUP_TAXONOMY_KEY, 'HAIR_MAKEUP'), _vendorTaxonomyKeys.PHOTOGRAPHERS_TAXONOMY_KEY, 'PHOTOGRAPHER'), _vendorTaxonomyKeys.PLANNERS_TAXONOMY_KEY, 'PLANNER'), _vendorTaxonomyKeys.VIDEOGRAPHERS_TAXONOMY_KEY, 'VIDEOGRAPHER'));